import type { ScheduleTime } from '@src/core/buyerApiClient';

type ScheduleTimesByProduct = {
  availableScheduleTimes: ScheduleTime[] | null | undefined;
};

const formatTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

export function intersectCommonScheduleTimes(products: ScheduleTimesByProduct[]): ScheduleTime[] {
  if (!products.length) {
    return [];
  }

  // A product with no offered times cannot satisfy any slot — treat it as blocking overlap.
  if (products.some((product) => !product.availableScheduleTimes?.length)) {
    return [];
  }

  const [first, ...rest] = products;
  const commonMinutes = (first!.availableScheduleTimes ?? [])
    .map((time) => time.minutes)
    .filter((minutes) =>
      rest.every((product) => product.availableScheduleTimes?.some((time) => time.minutes === minutes)),
    );

  const uniqueMinutes = [...new Set(commonMinutes)].sort((a, b) => a - b);

  return uniqueMinutes.map((minutes) => ({
    minutes,
    formattedTime: formatTime(minutes),
  }));
}
